import {
  ADMIN_REFERRALS,
  ADMIN_REFERRAL_DETAILS,
  Div,
  P,
  UnderlineHoverLink,
  lightTheme,
  restaurantReferralStatusLabel,
} from '@vgrubs/components';
import { generatePath } from 'react-router';
import { useLocationReferralSummary } from '../hooks/useLocationReferralSummary';

type Props = {
  locationId: string;
  /** The search the "Referred N restaurants" link opens the list with. */
  locationName: string;
};

/**
 * The restaurant referral program, as it touches this location: the
 * restaurant that invited it, and how many it invited. Nothing at all when it
 * has neither, which is most locations.
 */
export const LocationReferralInfo = ({ locationId, locationName }: Props) => {
  const summary = useLocationReferralSummary(locationId);
  if (!summary) return null;

  const { referredBy, restaurantReferralsCount: count } = summary;
  if (!referredBy && count === 0) return null;

  return (
    <Div $flex $column $gap="2px">
      {referredBy && (
        <P $m="0">
          Referred by{' '}
          <UnderlineHoverLink
            to={generatePath(ADMIN_REFERRAL_DETAILS, {
              id: String(referredBy.referralId),
            })}
          >
            <b>{referredBy.name}</b>
          </UnderlineHoverLink>
          <span style={{ color: lightTheme.lightGray }}>
            {' · '}
            {restaurantReferralStatusLabel(referredBy.status)}
          </span>
        </P>
      )}
      {count > 0 && (
        <P $m="0">
          <UnderlineHoverLink
            to={`${ADMIN_REFERRALS}?query=${encodeURIComponent(locationName)}`}
          >
            Referred {count === 1 ? '1 restaurant' : `${count} restaurants`}
          </UnderlineHoverLink>
        </P>
      )}
    </Div>
  );
};
